module.exports = __webpack_public_path__ + "static/media/showcase.2c4c52d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/showcase.png
// module id = 1635
// module chunks = 0